import React, { Component } from "react";

class AdminSettings extends Component {
  render() {
    return <h5>Admin Settings</h5>;
  }
}

export default AdminSettings;
